import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { adminRoutes } from './admin/admin.routes'
import { analyticsRoutes } from './analytics/analytics.routes'
import { SignInComponent } from './auth/sign-in/sign-in.component'
import { SignUpComponent } from './auth/sign-up/sign-up.component'
import { SiteVisitorComponent } from './auth/site-visitor/site-visitor.component'
import { MfaSetupComponent } from './auth/mfa-setup/mfa-setup.component'
import { MfaVerifyComponent } from './auth/mfa-verify/mfa-verify.component'
import { bidsRoutes } from './bids/bids.routes'
import { equipmentRoutes } from './equipment/equipment.routes'
import { fabRoutes } from './fab/fab.routes'
import { fieldToolsRoutes } from './field-tools/field-tools.routes'
import { PunchListCompleteComponent } from './field-tools/punch-list/punch-list-complete.component'
import { TireDispatchComponent } from './field-tools/tire-dispatch/tire-dispatch.component'
import { SubcontractorTrainingWizardComponent } from './safety/subcontractor-training-wizard/subcontractor-training-wizard.component'
import { SwpppPublicActionComponent } from './field-tools/swppp/swppp-public-action.component'
import { SwpppPublicReportComponent } from './field-tools/swppp/swppp-public-report.component'
import { SwpppPublicSiteComponent } from './field-tools/swppp/swppp-public-site.component'
import { HomeComponent } from './home/home.component'
import { InProgressComponent } from './in-progress/in-progress.component'
import { homeRoutes } from './home/home.routes'
import { hrRoutes } from './hr/hr.routes'
// Import all module routes
import { meetingsRoutes } from './meetings/meetings.routes'
import { operationsRoutes } from './operations/operations.routes'
import { projectManagementRoutes } from './project-management/project-management.routes'
import { purchasingRoutes } from './purchasing/purchasing.routes'
import { safetyRoutes } from './safety/safety.routes'
import { RouteGuard } from './shared'
import { toolRoomRoutes } from './tool-room/tool-room.routes'

const routes: Routes = [
    { path: '', component: HomeComponent, canActivate: [RouteGuard] },
    { path: 'signin', component: SignInComponent },
    { path: 'signup', component: SignUpComponent },
    { path: 'mfa-setup', component: MfaSetupComponent },
    { path: 'mfa-verify', component: MfaVerifyComponent },
    { path: 'site-visitor', component: SiteVisitorComponent },
    { path: 'punch-list-complete/:token', component: PunchListCompleteComponent },
    { path: 'tire-dispatch/:token', component: TireDispatchComponent },
    { path: 'subcontractor-training/:token', component: SubcontractorTrainingWizardComponent },
    { path: 'swppp/site/:token', component: SwpppPublicSiteComponent },
    { path: 'swppp/report/:token', component: SwpppPublicReportComponent },
    { path: 'swppp/action/:token', component: SwpppPublicActionComponent },

    { path: 'in-progress', component: InProgressComponent, canActivate: [RouteGuard] },

    // If the user hits the api without authorization, .Net will redirect to 'Account/Login', so redirect to signin.
    { path: 'Account/Login', redirectTo: 'signin', pathMatch: 'full' },

    // Include all module routes
    ...meetingsRoutes,
    ...adminRoutes,
    ...hrRoutes,
    ...equipmentRoutes,
    ...operationsRoutes,
    ...bidsRoutes,
    ...toolRoomRoutes,
    ...analyticsRoutes,
    ...safetyRoutes,
    ...homeRoutes,
    ...projectManagementRoutes,
    ...fieldToolsRoutes,
    ...fabRoutes,
    ...purchasingRoutes,
]

@NgModule({
    imports: [RouterModule.forRoot(routes, { canceledNavigationResolution: 'computed' })],
    exports: [RouterModule],
})
export class AppRoutingModule {}
